import axios, { InternalAxiosRequestConfig } from 'axios';

import store from '../redux/store';

type AuthRequestConfig = InternalAxiosRequestConfig & {
  skipAuth?: boolean;
};

const authInterceptor = () =>
  axios.interceptors.request.use(
    (request) => {
      const currentRequest = request as AuthRequestConfig;
      const fromStore = store.getState().auth.authData;

      if (
        !currentRequest.skipAuth &&
        fromStore?.accessToken?.token &&
        currentRequest.headers
      ) {
        currentRequest.headers.Authorization = `Bearer ${fromStore.accessToken.token}`;
      }

      return currentRequest;
    },
    (error) => Promise.reject(error)
  );

export default authInterceptor;
